import { create } from "zustand";
import { persist } from "zustand/middleware";

interface SoundState {
	enabled: boolean;
	toggle: () => void;
	setEnabled: (v: boolean) => void;
}

/**
 * Preferencia global de sonidos del UI. Persistida en localStorage para que
 * el mute quede entre sesiones. El volumen de los assets vive en el hook
 * (useSendSound) — acá solo el toggle.
 */
export const useSoundStore = create<SoundState>()(
	persist(
		(set) => ({
			enabled: true,
			toggle: () => set((s) => ({ enabled: !s.enabled })),
			setEnabled: (v) => set({ enabled: v }),
		}),
		{ name: "crm-sound-prefs" },
	),
);
